import React, { Component } from 'react';

// Router
import {
  Switch, 
  Route,
  Link
} from 'react-router-dom';

// Conf
import conf from './_core/_conf';

// Core
import Loader from './_core/components/Loader';
import Site from './_core/components/Site';

import {Entry,Asset,Data} from './_core/models';

// Components
import Components from './_components';

// Project
import Layout from './templates/_layout';
import DataRouter from './components/Router';

// Cookies
import CookieManager from './_core/components/Cookie/CookieManager';
import CookieMessage from './_core/components/Cookie/CookieMessage';
import CookieTracker from './_core/components/Cookie/CookieTracker';

// Tracking
import GoogleAnalytics from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

class Index extends Component {


  constructor(props){

      super(props);
  }

  componentWillMount = () => {

      const _this = this;

  }



  render() {

    // Load the settings to get the manifest (JSON data to power the site)
    let settings = conf.get();
    

    return (
      <Switch>
        <Route path="/__components" render={()=>{

          return <Components />

        }}/>
        <Route render={()=>{

          return (
            <React.Fragment>
              <CookieTracker init={()=>{

                // Code to initialise when cookies are agreed
                /*GoogleAnalytics.initialize({

                    trackingId: 'GA-XXXXXXX',
                    debug: true

                });*/

                const advancedMatching = {};
                const options = {
                    autoConfig: true,   // set pixel's autoConfig
                    debug: false,     // enable logs
                };
                ReactPixel.init('606929930124678', advancedMatching, options);
                ReactPixel.pageView(); 

                return null;


              }}
              track={(page)=>{
                
                // Code to update on each page view
                ReactPixel.pageView();   

              }} />
              <CookieMessage />
              <Loader wait={1000} manifest={[{'label':'logo',src:'/ui/img/logo.svg'}]} progress={()=>{return <div className="Loader"><span></span></div>}} loaded={

                  ()=>(
                  <Site>
                    <DataRouter />
                  </Site>
                  )

              }/>
            </React.Fragment>

          )

        }} />
      </Switch>
      
      
    );
  }
}



export default Index;



// WEBPACK FOOTER //
// ./src/js/index.js